import { Motive as MotiveDto } from "../../../app/proxy/motives";
import { MotiveType } from "../../../app/proxy/motives/enums";

export class Motive {
  reasonId: number;
  name?: string;
  type: MotiveType;
  order: number;

  constructor(dto: MotiveDto) {
    Object.assign(this, dto);
  }
}